var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8626 71.4017C98.0628 69.3982 95.7905 68.4222 93.787 69.222C91.7834 70.0218 90.8075 72.2941 91.6073 74.2976C92.6241 76.8451 92.2907 79.7537 90.7153 82.0787C89.1391 84.4048 86.6155 85.739 83.7916 85.739H16.2243C13.144 85.739 10.4087 84.1318 8.90692 81.4392C7.40282 78.7421 7.47352 75.5638 9.09599 72.9367L42.8796 18.2387C44.4179 15.7481 47.0826 14.2611 50.008 14.2611C52.9334 14.2611 55.5978 15.7481 57.1363 18.2387L82.1221 58.6927C83.2557 60.528 85.6627 61.0974 87.4977 59.9632C89.3329 58.8298 89.902 56.423 88.7682 54.5876L63.7822 14.1336C60.8103 9.32188 55.6611 6.44922 50.0078 6.44922C44.3545 6.44922 39.2052 9.32208 36.2333 14.1336L2.44969 68.8318C-0.682352 73.9033 -0.81868 80.0388 2.08465 85.2445C4.98563 90.4457 10.2714 93.5508 16.2243 93.5508H83.7916C89.2483 93.5508 94.129 90.9662 97.1823 86.4603C100.213 81.988 100.841 76.3585 98.8626 71.4017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0099 78.1228C52.1671 78.1228 53.9157 76.3741 53.9157 74.2169C53.9157 72.0597 52.1671 70.311 50.0099 70.311H50.0079C47.8507 70.311 46.103 72.0597 46.103 74.2169C46.103 76.3741 47.8526 78.1228 50.0099 78.1228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9138 60.546V31.8375C53.9138 29.6803 52.1651 27.9316 50.0079 27.9316C47.8507 27.9316 46.1021 29.6803 46.1021 31.8375V60.546C46.1021 62.7032 47.8507 64.4518 50.0079 64.4518C52.1651 64.4518 53.9138 62.7032 53.9138 60.546Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f5e73379d37d8759f97d6412571e0e9e.svg";
export { ForwardRef as ReactComponent };